<template>
  <div>
    <div class="player-container-info">
      <div
        class="highlighted"
        v-if="item.highlight == 1"
      >
        <p>Highlighted</p>
      </div>
      <div
        class="image-container"
        @click.prevent="handleViewDetails(item.id)"
      >
        <img
          :src="item_image"
          alt="thumbnail"
          class="img-fluid"
        />
      </div>

      <div class="player-container-info__overlay">
        <div
          class="player-container-info__overlay__disable"
          data-bs-tooltip="Disable"
          data-bs-placement="top"
        >
         
          <div
            class="btn-disable btn-highlight"
            data-bs-tooltip="Make Highlight"
            data-bs-placement="top"
            role="button"
            @click.prevent="handleViewItem(item.id)"
          >
            <i class="fa fa-edit"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="video-details"
      @click.prevent="handleViewDetails(item.id)"
    >
      <h5 class="text-start">{{ item.title }}</h5>
      <p>{{ item.description }}</p>
    </div>

    <deleteModal
      :item="item"
      @handleRemovedItem="deleteItem"
      v-if="!showDeleteModal"
      :key="item.id"
    />
  </div>
</template>

<script>
import CustomPlayer from './custom-player.vue';
import deleteModal from './delete-warning.vue';
import axios from 'axios';

export default {
  name: 'item-container',
  props: {
    item: {
      type: Object,
      required: true,
    },
    item_image: {
      type: String,
      required: false,
    },
  },
  components: { CustomPlayer, deleteModal },

  data() {
    return {
      showDeleteModal: false,
    };
  },

  methods: {
    async deleteItem() {
      try {
        const response = await axios.delete(
          '/creator/flix-playlist/item/disable?item_id=' + this.item.id,
        );
        if (response.data.success) {
          this.showDeleteModal = false;
          this.$emit('handleRemovedItem', this.item.id);
        }
        notify('success', response.data.message);
      } catch (error) {
        console.log(error);
        notify('error', error.response.data.message);
      }
    },

    handleViewItem(item_id) {
      const url = `/creator/flix-playlist/${item_id}/edit-item`;
      window.location = url;
    },
    handleViewDetails(item_id) {
      this.$emit('handleViewDetails', item_id);
    },
    handleShowModalDelete() {
      $('#deleteModal').modal('show');
      this.showDeleteModal = true;
    },
  },
};
</script>
<style>
.player-container-info {
  position: relative;
  overflow: hidden;

  &:hover {
    .player-container-info__overlay {
      display: block;
      transition: all 0.3s ease-in-out;
      transform: translateX(0%);
    }
  }
}
.highlighted {
  position: absolute;
  top: 10px;
  right: 0;
  background-color: #0f4c47;
  color: #fff !important;
  padding: 0.5rem;
  border-radius: 10px 0px 0px 10px;
  font-size: 12px;
  font-weight: 600;
  z-index: 9;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease-in-out;
  user-select: none;
}
.highlighted p {
  margin: 0;
  color: #fff !important;
}
.player-container-info__overlay {
  position: absolute;
  bottom: 50%;
  right: 0;
  width: 61px;
  height: 100px;
  transition: all 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0.5rem;
  border-radius: 10px 0px 0px 10px;
  backdrop-filter: blur(11px);
  transform: translateX(100%);
}
.player-container-info__overlay__disable {
  color: #fff;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: auto;
  height: 100%;
}

.btn-disable {
  background-color: #fff;
  padding: 0.7rem;
  color: #000;
  transition: all 0.3s ease-in-out;
  align-items: cem;
  text-align: center;
  display: flex;
  border-radius: 5px;
  &:hover {
    background-color: #000;
    color: #fff;
    border: 1px solid #fff;
  }
}
.video-details {
  padding: 0.5rem;
}
.player-container-info__overlay__disable {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.btn-highlight {
  background-color: #ff9f43 !important;
  color: #fff !important;
  margin-top: 10px;

  &:hover {
    background-color: #fff !important;
    color: #ff9f43 !important;
    border: 1px solid #ff9f43 !important;
    cursor: pointer;
  }
}

.image-container {
  height: 450px;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    .img-fluid {
      transform: scale(1.1);
      transition: all 0.3s ease-in-out;
    }
  }
}
.image-container img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>
